import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PasswordGate from "@/components/landing/PasswordGate";

function App() {
  return (
    <BrowserRouter>
      <PasswordGate>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </PasswordGate>
    </BrowserRouter>
  );
}

export default App;
